/**
 * Shared, non-secret configuration. Anything in here is safe to ship to the
 * browser. Secrets live in `.env`; live-editable settings live in the database
 * (see `BotConfiguration`) and are managed from the admin panel.
 */

/** Bot menu callback ids — the contract between keyboards and handlers. */
export const BOT_ACTIONS = {
  SUBMENU: 'submenu',
  CONTACT_ACCOUNT_MANAGER: 'contact_am',
  LIVE_CHAT: 'live_chat',
  BACK_TO_MENU: 'back_to_menu',
  END_SESSION: 'end_session',
  DIRECT_CONTACT: 'direct_contact',
} as const;

export type BotAction = (typeof BOT_ACTIONS)[keyof typeof BOT_ACTIONS];

/** Fallback copy used until an admin overrides it from the panel. */
export const DEFAULT_BOT_TEXTS = {
  welcomeMessage: 'سلام! چطور می‌توانیم کمکتان کنیم؟',
  fallbackMessage: 'متوجه نشدم. لطفاً یکی از گزینه‌های منو را انتخاب کنید.',
  menuAccountManager: '👤 ارتباط با کارشناس',
  menuLiveChat: '💬 گفتگوی آنلاین',
  liveChatText: 'جهت ورود به گفتگوی آنلاین دکمه زیر را انتخاب کنید',
  backToMenu: '⬅️ بازگشت به منو',
  endSession: '✅ پایان گفتگو',
  routedToManager: 'برای ارتباط با کارشناس دکمه زیر را انتخاب کنید',
  noManagerAvailable: 'در حال حاضر کارشناسی در دسترس نیست. لطفاً بعداً تلاش کنید.',
  featureDisabled: 'این گزینه در حال حاضر غیرفعال است.',
  directContact: '📞 ارتباط مستقیم',
} as const;

/** Seed values for the dynamic config row created on first boot. */
export const DEFAULT_BOT_CONFIG = {
  liveChatUrl: 'https://example.com/live-chat',
  isRoundRobinActive: true,
  activeAccountManagers: [] as string[],
  fallbackMessage: DEFAULT_BOT_TEXTS.fallbackMessage,
  welcomeMessage: DEFAULT_BOT_TEXTS.welcomeMessage,
  menu: {
    accountManagerEnabled: true,
    liveChatEnabled: true,
  },
} as const;

/** API conventions shared by client and server. */
export const API = {
  prefix: '/api',
  defaultPageSize: 25,
  maxPageSize: 100,
  /** Default analytics window, in days. */
  defaultAnalyticsRangeDays: 30,
  authTokenStorageKey: 'bale-bot.admin.token',
} as const;

/** Admin panel theme constants (consumed by MUI's createTheme). */
export const UI_THEME = {
  primaryColor: '#10b981',
  secondaryColor: '#B91048',
  borderRadius: 10,
  drawerWidth: 232,
  fontFamily: '"Roboto", "Vazirmatn", "Segoe UI", sans-serif',
} as const;
